import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface CardHeaderProps {
  image?: ReactNode
  sideActions?: ReactNode
  subtitle?: ReactNode
  title: ReactNode
}

export const CardHeader = ({ image, sideActions, subtitle, title }: CardHeaderProps): ReactElement => {
  return (
    <Flex justifyContent="space-between" gap={Spacing.S6}>
      <Flex alignItems="center" gap={Spacing.S6}>
        {image && <Styled.ImageWrapper>{image}</Styled.ImageWrapper>}
        <Flex flexDirection="column">
          <Text variant="bodyLG" weight="bold">
            {title}
          </Text>
          {subtitle && (
            <Text variant="bodySM" colorVariant="secondary">
              {subtitle}
            </Text>
          )}
        </Flex>
      </Flex>
      {sideActions}
    </Flex>
  )
}
